import * as React from 'react';
import { Box } from '@wix/design-system';
import type { AppBoxProps } from '../../components/app-box';
import type {
  ExternalComponentProps,
  ComponentsWithSiteContextProps,
} from '../types';
import { withEssentialsContext } from '../../contexts/essentials-context';
import { AppBasicInfo } from '../../components/quick-info-elements/app-basic-info';
import { AppGallery } from '../../components/quick-info-elements/app-gallery';
import type { Media } from './types';
import { withSiteContext } from '../../contexts/site-context';

export interface QuickInfoProps
  extends Omit<AppBoxProps, 'slug'>,
    ExternalComponentProps,
    ComponentsWithSiteContextProps {
  media: Media[];
  onCompanyClick: (companySlug: string) => void;
  onReviewsClick: (reviewsAmount: number) => void;
  onGalleryChange: (oldIndex: number, newIndex: number) => void;
  mainActionButton: React.ReactNode;
}

function QuickInfoComp({
  appData,
  media,
  onCompanyClick,
  mainActionButton,
  onReviewsClick,
  onGalleryChange,
}: QuickInfoProps) {
  return (
    <Box align="space-between" marginTop="6px" dataHook="quick-info-section">
      <AppBasicInfo
        appData={appData}
        onCompanyClick={onCompanyClick}
        onReviewsClick={onReviewsClick}
        mainActionButton={mainActionButton}
      ></AppBasicInfo>
      <AppGallery media={media} onGalleryChange={onGalleryChange} />
    </Box>
  );
}

export const QuickInfo = withSiteContext(withEssentialsContext(QuickInfoComp));
